import Breadcrumb from '@/components/breadcrumb/Breadcrumb';
import { BodySm, H4 } from '@/components/ui/typography/Typography';
import PageBannerSkeletonContent from '../skeleton/PageBannerSkeletonContent';

export default function PageBanner({ title, description, image, loading }) {
  return (
    <div
      className="
        relative w-full h-[340px] md:h-[340px] lg:h-[420px] flex items-center
        bg-center md:bg-top
      "
      style={{
        backgroundImage: `url(${image})`,
        backgroundSize: 'cover',
      }}
    >
      <div className="absolute inset-0 bg-black/70"></div>

      <div className="w-full lg:w-10/12 max-w-screen-2xl mx-auto px-5 z-10">
        {loading ? (
          <PageBannerSkeletonContent />
        ) : (
          <>
            {/* Breadcrumb */}
            <Breadcrumb />

            <H4 className="text-white py-4 w-10/12 lg:w-1/2">{title}</H4>

            {description && (
              <div className="w-10/12 lg:w-1/2">
                <BodySm className="text-white">{description}</BodySm>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
